import { RESET_PICKUP_ADDRESS_ENDPOINT } from 'bento-ordering/base/constants/endpoints';
import { apiAction } from 'bento-ordering/base/utils/apiHelpers';
import {
  RESET_PICKUP_ADDRESS_REQUEST,
  RESET_PICKUP_ADDRESS_SUCCESS,
  RESET_PICKUP_ADDRESS_FAILURE
} from 'bento-ordering/cart/constants/actionTypes';

export const TYPES = [
  RESET_PICKUP_ADDRESS_REQUEST,
  {
    type: RESET_PICKUP_ADDRESS_SUCCESS,
    payload: (action, state, res) => {
      window.location.reload();
    }
  },
  RESET_PICKUP_ADDRESS_FAILURE
];

const resetPickupAddress = () => dispatch => {
  const endpoint = RESET_PICKUP_ADDRESS_ENDPOINT;

  return dispatch(apiAction(endpoint, 'GET', TYPES));
};

export default resetPickupAddress;
